"use strict";

require("core-js/modules/es6.function.bind");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

function isDef(value) {
  return value !== undefined && value !== null;
}

var Backoff =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(Backoff, _events_1$EventEmitte);

  function Backoff(options) {
    var _this;

    _classCallCheck(this, Backoff);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Backoff).call(this));
    options = options || {};

    if (isDef(options.initialDelay) && options.initialDelay < 1) {
      throw new Error('The initial timeout must be equal to or greater than 1.');
    } else if (isDef(options.maxDelay) && options.maxDelay <= 1) {
      throw new Error('The maximal timeout must be greater than 1.');
    } else if (isDef(options.randomisationFactor) && (options.randomisationFactor < 0 || options.randomisationFactor > 1)) {
      throw new Error('The randomisation factor must be between 0 and 1.');
    } else if (isDef(options.factor) && options.factor <= 1) {
      throw new Error("Exponential factor should be greater than 1.");
    }

    _this.initialDelay = options.initialDelay || 100;
    _this.maxDelay = options.maxDelay || 10000;

    if (_this.maxDelay <= _this.initialDelay) {
      throw new Error('The maximal backoff delay must be greater than the initial backoff delay.');
    }

    _this.randomisationFactor = options.randomisationFactor || 0;
    _this.factor = options.factor || 2;
    _this.maxNumberOfRetry = -1;

    _this.reset();

    return _this;
  }

  _createClass(Backoff, [{
    key: "backoff",
    value: function backoff(err) {
      if (this.timeoutID == null) {
        if (this.backoffNumber === this.maxNumberOfRetry) {
          this.emit('fail', err);
          this.reset();
        } else {
          this.backoffDelay = this.next();
          this.timeoutID = setTimeout(this.onBackoff.bind(this), this.backoffDelay);
          this.emit('backoff', this.backoffNumber, this.backoffDelay, err);
        }
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.backoffDelay = 0;
      this.nextBackoffDelay = this.initialDelay;
      this.backoffNumber = 0;
      clearTimeout(this.timeoutID);
      this.timeoutID = null;
    }
  }, {
    key: "failAfter",
    value: function failAfter(maxNumberOfRetry) {
      if (maxNumberOfRetry <= 0) {
        throw new Error("Expected a maximum number of retry greater than 0 but got ".concat(maxNumberOfRetry));
      }

      this.maxNumberOfRetry = maxNumberOfRetry;
    }
  }, {
    key: "next",
    value: function next() {
      this.backoffDelay = Math.min(this.nextBackoffDelay, this.maxDelay);
      this.nextBackoffDelay = this.backoffDelay * this.factor;
      var randomisationMultiple = 1 + Math.random() * this.randomisationFactor;
      return Math.min(this.maxDelay, Math.round(this.backoffDelay * randomisationMultiple));
    }
  }, {
    key: "onBackoff",
    value: function onBackoff() {
      this.timeoutID = null;
      this.emit('ready', this.backoffNumber, this.backoffDelay);
      this.backoffNumber++;
    }
  }], [{
    key: "exponential",
    value: function exponential(options) {
      return new Backoff(options);
    }
  }]);

  return Backoff;
}(events_1.EventEmitter);

exports.Backoff = Backoff;
exports["default"] = Backoff;